// Email-blast axios instance — points at /api/email-blast, reuses the same
// master-PIN token via the shared consult authSession.
import axios from "axios";
import { getToken, clearToken } from "./authSession";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const blastApi = axios.create({
  baseURL: `${BACKEND}/api/email-blast`,
});

blastApi.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers["X-Auth-Token"] = t;
  return config;
});

blastApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) clearToken();
    return Promise.reject(err);
  },
);
